import React from 'react';
import styled from 'styled-components';
import { Divider, Button, ButtonEnums, Link } from 'components/atoms';
import { generatePath } from 'react-router-dom';
import { Routes } from 'constants/index';
import { getPath } from 'utils';
export interface FollowTrendIF {
  id: string;
  name: string;
  slug: string;
}
export interface Props {
  trends: FollowTrendIF[];
  userTrendsPref: string[];
  toggleTrendPref: (trendId: string, isOnEvent: boolean) => void;
}

export const ContentTrendsFollow: React.FC<Props> = props => {
  const { trends, userTrendsPref, toggleTrendPref } = props;
  const handleToggleTrend = React.useCallback(
    (trendId: string, isOnEvent: boolean) => {
      toggleTrendPref(trendId, isOnEvent);
    },
    [toggleTrendPref]
  );

  return (
    <>
      {trends.length !== 0 && (
        <>
          <StyledLargeHeading tabIndex={0}>Trends</StyledLargeHeading>
          {trends.map(trend => {
            const isActive: boolean = userTrendsPref.includes(trend.id);
            const isOnEvent: boolean = !isActive;
            return (
              <StyledTopicLine key={trend.id} data-testid={`sub-${trend.id}`}>
                <StyledTopicLink to={generatePath(getPath(Routes.TREND_AGGS_PAGE), { trendSlug: trend.slug })}>
                  {trend.name}
                </StyledTopicLink>
                <StyledFollowButton
                  active={isActive}
                  testId={`follow-${trend.id}`}
                  onClick={handleToggleTrend.bind(null, trend.id, isOnEvent)}
                  iconName={isActive ? 'check' : 'plus'}
                  iconPosition={ButtonEnums.iconPosition.left}
                  variant={ButtonEnums.variants.primaryToggle}
                  toggle
                  bordered
                >
                  {isActive ? 'Following' : 'Follow'}
                </StyledFollowButton>
              </StyledTopicLine>
            );
          })}
          <Divider />
        </>
      )}
    </>
  );
};

const StyledLargeHeading = styled.h3`
  font-weight: ${props => props.theme.fontWeights.light};
  font-size: ${props => props.theme.fontSizes.l};
  margin: ${props => props.theme.pxToRem(20)} 0 ${props => props.theme.pxToRem(25)};
  line-height: 1.5;
`;

const StyledTopicLine = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.pxToRem(20)};
`;

const StyledTopicLink = styled(Link)`
  margin: ${props => props.theme.pxToRem(8)} 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${props => props.theme.fontSizes.s};
  font-weight: ${props => props.theme.fontWeights.medium};
`;

const StyledFollowButton = styled(Button)`
  ${props => props.theme.mediaQueries.computerMin} {
    &.toggle:focus {
      border: ${props => props.theme.pxToRem(1)} solid
        ${props => (props.bordered ? props.theme.colors.primaryLightPurple : 'transparent')};
      background-color: ${props => props.theme.colors.primaryLightPurple} !important;
      color: ${props => props.theme.colors.neutralWhite} !important;
    }

    &.toggle.active:hover {
      border: ${props => props.theme.pxToRem(1)} solid
        ${props => (props.bordered ? props.theme.colors.interfaceRed : 'transparent')};
      background-color: ${props => props.theme.colors.interfaceRed} !important;
    }
  }
`;
